module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAAsCAYAAAAehFoBAAAAAXNSR0IArs4c6QAAAPlJREFUWEftmLENwjAQRV92gI4l2ICCESigYAsaZqBgCSSQWICCHVgCKhgCGQUJRQkp+LY46adOLi/PZ/vHFcGuKhgvBs49YmrDI2ALTGrwM7ACbqoPUQIn2AswaMA9gDFwVUArgY/ArAPqACz+DfjeYvfNmCwPDfyjgT0w76ixA5Y/1n89ruzhcJMuCUjQG2Ba2zwBa9UKoTasGPHeGsqW6H2Z4gYDKyx+q2HD0Qw7rTVHTNnDTmtt80FpOFy8dFrL3RJOayUM597opH8c2WEd4EsoVm4cJXjlPey05rT2YSBc+AkH7LRWIkv4bC3nshZyp8sOHS5LPAFqPDwt5aOacAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/report/year2023/history.png
// module id = puU1
// module chunks = 0